export const TRADE_CATEGORIES = [
  {
    id: "handloom-home",
    n: "01",
    name: "Handloom & Home Furnishing",
    items: ["Kerchief", "Lungies", "Vestis & Dhoties", "Thundu (Angavasthram)", "Swamy Items", "Napkins & Towels", "Shawls & Ponnadai", "Katchi Items", "Mull & Gada", "Door & Window Screens", "Bedsheets", "Bedspreads", "Blankets", "Pillow Covers"],
  },
  {
    id: "running-materials",
    n: "02",
    name: "Running Materials & Saree Accessories",
    items: ["Blouse & Lining Materials", "Blouse Readymade & Bits", "Inskirt Readymade & Fabric", "Night Gowns Readymade & Bits"],
  },
  {
    id: "sarees",
    n: "03",
    name: "Sarees",
    items: ["Poonam", "Renial", "Chiffon", "Voil", "Cotton", "Plain Sarees", "Lehengas"],
  },
  {
    id: "western-wear",
    n: "04",
    name: "Men & Women Western Wear",
    items: ["Churidar Readymade & Materials", "Kurtis", "Dupatta", "Bottom Wear", "Shirts", "Pants", "Jeans", "T-Shirts", "Trackpants & Shorts"],
  },
  {
    id: "innerwear",
    n: "05",
    name: "Men & Women Innerwear",
    items: ["Vests", "Briefs & Trunks", "Boxers", "Camisoles", "Panties", "Thermals"],
  },
  {
    id: "shirtings-suitings",
    n: "06",
    name: "Shirting & Suiting",
    items: ["Shirting Fabrics", "Suiting Fabrics"],
  },
  {
    id: "uniforms",
    n: "07",
    name: "All kinds of Uniform Fabrics",
    items: ["Uniform Fabrics", "Govt. Readymade Uniforms"],
  },
  {
    id: "tailored-orders",
    n: "08",
    name: "Tailored & Customized Orders Taken",
    items: ["Tailored Orders", "Customized Orders"],
  },
];

export const CATEGORY_ALIASES = { "blouse-women": "running-materials", "women-western": "western-wear", "men-wear": "western-wear" };

export const ENQUIRY_CATEGORIES = [...TRADE_CATEGORIES.map((c) => c.name), "Multiple Categories"];

export const CONTACT = {
  waNumber: "919889886321",
  phones: [
    { label: "Customer Care", display: "+91 98898 85321", href: "tel:+919889885321" },
    { label: "Sales Support", display: "+91 98898 86321", href: "tel:+919889886321" },
  ],
  whatsapp: "https://wa.me/919889886321?text=Thanks%20for%20contacting%20Praveen%20Textiles!%20Let%20us%20know%20what%20you%27re%20looking%20for%20%E2%80%94%20product%20and%20quantity%20%E2%80%94%20and%20we%27ll%20get%20back%20to%20you%20shortly%20with%20stock%20and%20rates.",
  email: "sales@praveentextiles.com",
  address: "Old No.21, New No.53, M.C. Road, Old Washermenpet, Chennai — 600021, Tamil Nadu, India",
  hours: "Mon–Sat · 10:00 AM – 8:00 PM",
};
